/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "vidhub-20200314091410-hostingbucket-prodhub",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "https://d1xzj63c8dqlov.cloudfront.net",
    "aws_cognito_identity_pool_id": "us-east-1:8ff8090b-6e55-41f7-85f5-c590644d007d",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_hwcACq2QD",
    "aws_user_pools_web_client_id": "jkjehaq9pdac2s56l87b6qcvl",
    "oauth": {
        "domain": "vidhubd-prodhub.auth.us-east-1.amazoncognito.com",
        "scope": [
            "phone",
            "email",
            "openid",
            "profile",
            "aws.cognito.signin.user.admin"
        ],
        "redirectSignIn": "https://d1xzj63c8dqlov.cloudfront.net/",
        "redirectSignOut": "https://d1xzj63c8dqlov.cloudfront.net/",
        "responseType": "code"
    },
    "federationTarget": "COGNITO_USER_POOLS",
    "aws_user_files_s3_bucket": "vidhubs3215238-prodhub",
    "aws_user_files_s3_bucket_region": "us-east-1",
    "aws_appsync_graphqlEndpoint": "https://pecikvankrfstoe2t2jtkfuh6u.appsync-api.us-east-1.amazonaws.com/graphql",
    "aws_appsync_region": "us-east-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://tl9xu36la8.execute-api.us-east-1.amazonaws.com/prodhub",
            "region": "us-east-1"
        }
    ],
    "aws_mobile_analytics_app_id": "d55218db3b6a41d0ad89ff5724cd7909",
    "aws_mobile_analytics_app_region": "us-east-1"
};


export default awsmobile;
